// extracted by mini-css-extract-plugin
export default {"TabNav":"TabNav_ko_uu_v17-8-1","TabNav_Items":"TabNav_Items_ad_cY_v17-8-1","TabNav_Aux":"TabNav_Aux_ROUPT_v17-8-1"};